import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { action, computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { IButtonProps } from '@kurtosys/ksys-app-components/dist/components/base/Button/models';
import { ICsvDownloaderOptions } from '../models/ICsvDownloaderOptions';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';
import { Manifest } from '../../../configuration/Manifest';
import { DownloadStore } from './DownloadStore';
import { utils } from '@kurtosys/ksys-app-template';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	downloadStore: DownloadStore;

	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
		this.downloadStore = new DownloadStore(this.storeContext);
	}

	@computed
	get hasData(): boolean {
		const rows = this.downloadStore.rows;
		return !utils.typeChecks.isNullOrEmpty(rows);
	}

	// Override base call, to check for custom noDataText config.
	@computed
	get noDataPlaceholder(): string | undefined {
		return this.appComponentConfiguration && this.appComponentConfiguration.noDataOptions && this.appComponentConfiguration.noDataOptions.noDataPlaceholder || this.noDataText;
	}

	@action
	contextsDidUpdateAfter = async () => {
		// TODO: Each Application should put custom logic here to handle changes to the data context
	};

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get loadingText() {
		return (this.appComponentConfiguration && this.appComponentConfiguration.loadingText) || 'Loading...';
	}

	@computed
	get buttonProps(): IButtonProps {
		const config = this.appComponentConfiguration;
		const props = config && config.buttonProps;
		const { isLoading } = this.downloadStore;
		const useSpinner = config && config.useSpinner;
		const downloadIcon = config && config.downloadIcon;
		const spinnerIcon = config && config.spinnerIcon;
		const iconAsset =
			isLoading && useSpinner ?
				spinnerIcon :
				downloadIcon;

		const response: IButtonProps = {
			disabled: isLoading,
			text: isLoading && !useSpinner ? this.loadingText : (props || {}).text,
			iconProps: {
				asset: iconAsset,
			},
			onClick: () => {
				this.downloadStore.initialize();
			},

			suppressAnalytics: true,
		};
		return utils.object.deepMergeObjects(props || {}, response);
	}

	get cardProps(): ICardProps | undefined {
		const cardProps = this.appComponentConfiguration && this.appComponentConfiguration.cardProps;
		return this.mergeQueriesAndProps(cardProps);
	}

	@computed
	get csvDownloaderOptions(): ICsvDownloaderOptions | undefined {
		return this.appComponentConfiguration && this.appComponentConfiguration.csvDownloaderOptions;
	}

	@computed
	get noDataText(): string {
		const noDataTextQueryOptions = this.appComponentConfiguration && this.appComponentConfiguration.noDataText;
		return this.getQueryValue(noDataTextQueryOptions);
	}

}
